"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var Radio_1 = __importDefault(require("../radio/Radio"));
/**
 * @component RadioGroup
 * @example
 * <RadioGroup
 *    data={radioButtonData}
 *    name="mood"
 *    direction={direction}
 *    formik={formik}
 *  />
 *
 * @param {data[]} data data to pass into the RadioGroup
 * @param {string} name formik name of the field
 * @param {string} direction one of 'row' | 'column';
 * @param {number} horizontalSpacing padding from 1-8 to the right of every item when direction is 'row'
 * @param {any} formik the Formik object from the form that this component is being used in
 */
function RadioGroup(props) {
    var data = props.data, name = props.name, _a = props.direction, direction = _a === void 0 ? 'column' : _a, _b = props.horizontalSpacing, horizontalSpacing = _b === void 0 ? 4 : _b, formik = props.formik;
    return (react_1.default.createElement(material_1.Grid, { container: true, direction: direction }, data.map(function (radio) { return (react_1.default.createElement(material_1.Grid, { key: radio.id, className: "mr-".concat(horizontalSpacing) },
        react_1.default.createElement(Radio_1.default, { id: radio.id, name: name, label: radio.label, value: radio.value, checked: radio.value === formik.values[name], onChange: formik.handleChange }))); })));
}
exports.default = RadioGroup;
